import Vue from "vue"
import { registerMicroApps } from "qiankun"
import language from "./assets/messages/language"

// 一、准备菜单服务数据
// 1、左侧导航
let leftNav = []
// 2、顶部品牌信息区
let systemLogo = {
  imgPath: "/imgs/systemLogo.png"
}
//3、用户信息区
let userInfo = {}
// 4、左侧应用信息区
let clientLogo = {
  imgPath: "/imgs/clientLogo.png",
  name: "IDaaS管理平台"
}

// let assistMenu = [
//   {
//     label: "切换语言",
//     isSpa: true,
//     children: [
//       {
//         label: "中文（简体）",
//         path:`?language=zh-CN`,
//         isSpa: false,
//       },
//       {
//         label: "English",
//         path: `?language=en`,
//         isSpa: false,
//       },
//     ],
//   }
// ];

clientLogo.name = language.language =='en' ? 'IDAAS' : 'IDaaS管理平台'
if(location.origin.indexOf('qikan') > -1 || location.origin.indexOf('journal') > -1 ) {
  let $favicon = document.querySelector('link[rel="icon"]');
  if ($favicon !== null) {
      $favicon.href = 'favicon-qikan.png';
  }
  systemLogo.imgPath = "/imgs/systemLogo-qikan.png"
  clientLogo.name = language.language =='en' ? 'IDAAS' : "学者通行证"
} else {
  // assistMenu = []
}
// 二、菜单服务配置 导航菜单服务地址
let menuUrl =
process.env.NODE_ENV === "development"
  ? "http://menu.test.fzyun.io/"
  // ? "http://172.19.31.34:1111/" 本地导航菜单服务地址
  : "https://frameui.sdk.fzyun.cn"
const apis = [
  {
    name: "menuService",
    // entry: "http://menu.test.fzyun.io/",
    entry: menuUrl,
    container: "#menuContainer",
    props: {
      leftNav,
      systemLogo,
      userInfo,
      clientLogo
      // assistMenu
    },
    // 自定义规则：函数返回值为true，则展示菜单服务，否则不展示菜单服务
    activeRule: () => location.pathname.startsWith("/")
  }
]

// 三、注册菜单服务
registerMicroApps(apis, {
  beforeLoad: () => {
    // 2、可以在该处监听左侧菜单是否为固定宽度模式的切换
    window.addEventListener("fixedNavChange", function(e) {
      // e.detail.isFixed：
      // true：当前左侧菜单为固定宽度模式，需要把页面内容区整体右移e.detail.leftNavWidth个距离
      // false：当前左侧菜单为非固定宽度模式，需要把页面内容区恢复初始位置
      // e.detail.leftNavWidth
      // 固定模式菜单的宽度
      let dom = document.querySelector(
        ".ids-common-layout .el-aside.idsLeftNav"
      )
      if (dom) {
        dom.style.width = (e.detail.isFixed ? e.detail.leftNavWidth : 50) + "px"
      }
    })
    // 2、可以在该处监听菜单切换事件
    window.addEventListener("menuServeChanged", function(e) {
      // e.detail.path：
      // 当前点击菜单项的路径
      // 监听到是退出，调用退出逻辑
      if (e.detail.path === "/menuServeLogout") {
        Vue.prototype.$keycloak.logoutFn()
        localStorage.removeItem('locale')
      }
    })
  },
  afterMount: [
    () => {
      // 1、可以在该处向菜单服务中添加自定义功能
    }
  ]
})

// 四、启动菜单服务。需要在vue挂载后，再启动
